export enum BasicOperators {
  ADD = 'add',
  REMOVE = 'remove',
  SET = 'set',
  INCREMENT = 'inc',
  DECREMENT = 'dec'
}